module.exports = __webpack_public_path__ + "static/img/vouchers10.aabee404.png";